import { render } from "./TagAdd.vue?vue&type=template&id=5b1fee0c"
import script from "./TagAdd.vue?vue&type=script&lang=ts"
export * from "./TagAdd.vue?vue&type=script&lang=ts"
script.render = render

export default script